import client from '@config/client'

// Simple fetcher implementation for reliable loading state transitions
const fetcher = async (url, options = {}) => {
  try {
    // console.log('Fetching URL:', url)
    const res = await client.get(url, options)

    if (!res.ok) {
      // console.error('HTTP error:', res.status)
      throw new Error(`HTTP error: ${res.status}`)
    }

    return res.data
  } catch (error) {
    // console.error(`[FETCH] Error from ${url}:`, error.message || error)

    // Structure the error for easy consumption
    const errorObj = {
      status: error.response?.status || 500,
      message: error.message || 'Unknown error',
      url: url,
      details: error.response?.data || error.toString()
    }

    // console.error(`[FETCH] Structured error:`, errorObj)
    throw errorObj
  }
}

export default fetcher
